import { useQuery } from '@apollo/client/react';

import { getMemberIdWithFallback } from '@trello/authentication';

import { useBoardMembers } from '../useBoardMembers';
import {
  BoardAccessRequestsDocument,
  type BoardAccessRequestsQuery,
} from './BoardAccessRequestsQuery.generated';

type AccessRequests = NonNullable<
  NonNullable<BoardAccessRequestsQuery['board']>
>['accessRequests'];

export const useBoardAccessRequests = ({
  boardId,
}: {
  boardId: string;
}): {
  isMemberAdmin: boolean;
  loading: boolean;
  accessRequests: AccessRequests | undefined;
} => {
  const { isAdmin } = useBoardMembers(boardId);
  const memberId = getMemberIdWithFallback();
  const isMemberAdmin = isAdmin(memberId);

  const { data: accessRequestsData, loading } = useQuery(
    BoardAccessRequestsDocument,
    {
      variables: { boardId },
      skip: !isMemberAdmin,
      context: {
        operationName: 'BoardAccessRequests',
        document: BoardAccessRequestsDocument,
      },
    },
  );

  return {
    isMemberAdmin,
    loading,
    accessRequests: accessRequestsData?.board?.accessRequests,
  };
};
